/* Kick Frame — "See it on your wall": de poster op ware grootte boven een bank van 200 cm,
   zodat je ziet hoe groot A4, A3, A2 en A1 echt zijn. Formaat en afwerking lopen gelijk
   met de keuze in het productformulier. Alleen SVG, geen externe bibliotheek. */
(function () {
  var gallery = document.querySelector('.gallery-main');
  var form = document.querySelector('[data-product-form]');
  if (!gallery || !form) return;
  var firstThumb = document.querySelector('.thumbs .thumb');
  var mainImg = gallery.querySelector('img');
  var src = (firstThumb && firstThumb.getAttribute('data-full')) || (mainImg && mainImg.currentSrc) || '';
  if (!src) return;

  var SIZES = { A4: [21, 29.7], A3: [29.7, 42], A2: [42, 59.4], A1: [59.4, 84.1] };
  var NS = 'http://www.w3.org/2000/svg';

  // Radioknoppen van het formulier per optie ophalen
  function radios() {
    var size = [], finish = [];
    form.querySelectorAll('input[type=radio][data-option-position]').forEach(function (r) {
      var key = r.value.split(' (')[0].trim();
      if (SIZES[key]) size.push({ key: key, el: r });
      else {
        var f = /Framed|Eiken/.test(r.value) ? 'framed' : /Hanger|Ophangstok/.test(r.value) ? 'hanger' : 'poster';
        finish.push({ key: f, el: r });
      }
    });
    return { size: size, finish: finish };
  }
  var opts = radios();
  if (!opts.size.length) return;

  function current(list, fallback) {
    for (var i = 0; i < list.length; i++) if (list[i].el.checked) return list[i].key;
    return fallback;
  }

  // Kamer in centimeters: 320 breed, 250 hoog, vloer op y=222, bank 200 cm breed
  var W = 320, H = 250, FLOOR = 222, CENTER_Y = 86, CX = 160;

  var css = ''
    + '.kfw-open{position:absolute;left:.75rem;bottom:.75rem;z-index:3;display:inline-flex;align-items:center;gap:.4rem;'
    + 'padding:.55rem .9rem;border:1px solid rgba(255,255,255,.35);border-radius:999px;background:rgba(10,20,16,.72);'
    + 'color:#fff;font:600 .85rem/1 inherit;letter-spacing:.02em;cursor:pointer;backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px)}'
    + '.kfw-open:hover{background:var(--green,#2f8f5b);border-color:transparent}'
    + '.kfw-open svg{width:18px;height:18px}'
    // venster past altijd in beeld: niet scrollen, ook niet op de pagina eronder
    + '.kfw{position:fixed;inset:0;z-index:1000;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:.8rem;'
    + 'padding:4rem 1rem max(1rem,env(safe-area-inset-bottom));background:#0c1511;opacity:0;transition:opacity .25s;'
    + 'overflow:hidden;overscroll-behavior:contain;touch-action:none}'
    + '.kfw.is-open{opacity:1}'
    + '.kfw-scene{width:min(100%,76rem,calc((100vh - 13.5rem) * ' + (W / H) + '));width:min(100%,76rem,calc((100dvh - 13.5rem) * ' + (W / H) + '));'
    + 'border-radius:14px;overflow:hidden;box-shadow:0 30px 80px -30px rgba(0,0,0,.8);flex:0 0 auto}'
    + '.kfw-scene svg{display:block;width:100%;height:auto}'
    + '.kfw-title{color:#fff;font:600 1.05rem/1.3 inherit;text-align:center;margin:0}'
    + '.kfw-title small{display:block;font-weight:400;opacity:.65;font-size:.8rem;margin-top:.2rem}'
    + '.kfw-controls{display:flex;flex-wrap:wrap;justify-content:center;gap:.5rem 1.5rem}'
    + '.kfw-row{display:flex;flex-wrap:wrap;justify-content:center;gap:.5rem;touch-action:manipulation}'
    + '.kfw-chip{min-width:3.4rem;padding:.6rem .95rem;border-radius:999px;border:1px solid rgba(255,255,255,.3);background:transparent;'
    + 'color:#fff;font:600 .9rem/1 inherit;cursor:pointer}'
    + '.kfw-chip[aria-pressed=true]{background:#fff;color:#0c1511;border-color:#fff}'
    + '.kfw-close{position:absolute;top:1rem;right:1rem;width:44px;height:44px;border-radius:50%;border:1px solid rgba(255,255,255,.3);'
    + 'background:rgba(0,0,0,.35);color:#fff;font-size:1.5rem;line-height:1;cursor:pointer;touch-action:manipulation}'
    + '@media (max-width:38rem){.kfw-scene{border-radius:10px}.kfw-chip{padding:.55rem .8rem}.kfw{gap:.65rem}.kfw-controls{gap:.5rem}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'kfw-open';
  btn.setAttribute('aria-label', 'See this poster on a wall, at real size');
  btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
    + '<rect x="7" y="3" width="10" height="12" rx="1"/><path d="M3 21h18M5 21v-4h14v4"/></svg>On your wall';
  gallery.appendChild(btn);

  function f(n) { return String(Math.round(n * 10) / 10); }
  var F = FLOOR;
  var planks = '';
  for (var px = -60; px <= 380; px += 28) {
    planks += '<path d="M' + f(CX + (px - CX) * 0.72) + ' ' + F + ' L' + f(px) + ' ' + H + '" stroke="#000" stroke-opacity=".07" stroke-width=".4"/>';
  }
  var pampas = '';
  var stems = [[-16, -58], [-8, -66], [0, -70], [7, -64], [15, -56], [-12, -50], [11, -48]];
  stems.forEach(function (s, i) {
    var x0 = 289, y0 = F - 66, x1 = x0 + s[0], y1 = F + s[1] - 16;
    pampas += '<path d="M' + x0 + ' ' + y0 + ' Q ' + f(x0 + s[0] * 0.3) + ' ' + f(y0 - 18) + ' ' + f(x1) + ' ' + f(y1) + '" stroke="#b9a37f" stroke-width=".45" fill="none"/>'
      + '<ellipse cx="' + f(x1) + '" cy="' + f(y1) + '" rx="2.6" ry="9" fill="#e6d6b8" opacity=".95" transform="rotate(' + f(s[0] * 1.6) + ' ' + f(x1) + ' ' + f(y1) + ')"/>';
  });

  var room = ''
    + '<defs>'
    + '<linearGradient id="kfwWall" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#f1eee8"/><stop offset="1" stop-color="#e1dbd1"/></linearGradient>'
    + '<linearGradient id="kfwFloor" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#d2b289"/><stop offset="1" stop-color="#b8956b"/></linearGradient>'
    + '<linearGradient id="kfwSofa" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#474b51"/><stop offset="1" stop-color="#34373c"/></linearGradient>'
    + '<radialGradient id="kfwGlow" cx=".5" cy=".5" r=".5"><stop offset="0" stop-color="#fff4d6" stop-opacity=".75"/><stop offset="1" stop-color="#fff4d6" stop-opacity="0"/></radialGradient>'
    + '<filter id="kfwBlur" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="7"/></filter>'
    + '<filter id="kfwSoft" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="2.2"/></filter>'
    + '<filter id="kfwShadow" x="-20%" y="-20%" width="140%" height="160%"><feDropShadow dx="0" dy="1.6" stdDeviation="1.6" flood-color="#000" flood-opacity=".32"/></filter>'
    + '</defs>'
    // muur met schuin invallend daglicht
    + '<rect width="' + W + '" height="' + H + '" fill="url(#kfwWall)"/>'
    + '<path d="M210 0 L300 0 L200 ' + F + ' L100 ' + F + ' Z" fill="#fff" opacity=".28" filter="url(#kfwBlur)"/>'
    // plint en eiken vloer
    + '<rect y="' + (F - 5) + '" width="' + W + '" height="5" fill="#f7f5f1"/>'
    + '<rect y="' + (F - 5) + '" width="' + W + '" height=".5" fill="#000" opacity=".06"/>'
    + '<rect y="' + F + '" width="' + W + '" height="' + (H - F) + '" fill="url(#kfwFloor)"/>'
    + planks
    // vloerkleed
    + '<path d="M36 ' + (F + 3) + ' L284 ' + (F + 3) + ' L300 ' + (F + 24) + ' L20 ' + (F + 24) + ' Z" fill="#ebe4d8"/>'
    + '<path d="M36 ' + (F + 3) + ' L284 ' + (F + 3) + '" stroke="#d6ccbc" stroke-width=".6"/>'
    // booglamp links
    + '<ellipse cx="88" cy="' + (F - 170) + '" rx="26" ry="20" fill="url(#kfwGlow)"/>'
    + '<ellipse cx="28" cy="' + (F + 1) + '" rx="10" ry="2.2" fill="#161616"/>'
    + '<path d="M28 ' + F + ' V' + (F - 150) + ' Q28 ' + (F - 205) + ' 88 ' + (F - 190) + '" stroke="#161616" stroke-width="1.5" fill="none" stroke-linecap="round"/>'
    + '<path d="M77 ' + (F - 180) + ' Q88 ' + (F - 197) + ' 99 ' + (F - 180) + ' Z" fill="#161616"/>'
    // schaduw onder de bank
    + '<ellipse cx="' + CX + '" cy="' + (F + 2) + '" rx="112" ry="4" fill="#000" opacity=".22" filter="url(#kfwSoft)"/>'
    // lage moderne bank, 200 cm breed
    + '<g fill="url(#kfwSofa)">'
    + '<rect x="62" y="' + (F - 74) + '" width="196" height="34" rx="11"/>'
    + '<rect x="54" y="' + (F - 47) + '" width="212" height="29" rx="10"/>'
    + '<rect x="48" y="' + (F - 56) + '" width="20" height="40" rx="10"/>'
    + '<rect x="252" y="' + (F - 56) + '" width="20" height="40" rx="10"/>'
    + '</g>'
    + '<path d="M160 ' + (F - 46) + ' V' + (F - 20) + '" stroke="#2c2f33" stroke-width=".8"/>'
    + '<g fill="#111"><rect x="70" y="' + (F - 18) + '" width="2.4" height="18"/><rect x="248" y="' + (F - 18) + '" width="2.4" height="18"/></g>'
    // kussens
    + '<rect x="74" y="' + (F - 70) + '" width="30" height="27" rx="8" fill="#b9694b" transform="rotate(-8 89 ' + (F - 57) + ')"/>'
    + '<rect x="100" y="' + (F - 66) + '" width="24" height="22" rx="7" fill="#d9c7a8" transform="rotate(-4 112 ' + (F - 55) + ')"/>'
    + '<rect x="218" y="' + (F - 69) + '" width="29" height="26" rx="8" fill="#8fa18d" transform="rotate(7 232 ' + (F - 56) + ')"/>'
    // bijzettafel met vaas en pampasgras
    + '<ellipse cx="290" cy="' + (F - 47) + '" rx="17" ry="3.2" fill="#1b1b1b"/>'
    + '<rect x="289" y="' + (F - 47) + '" width="2" height="46" fill="#1b1b1b"/>'
    + '<ellipse cx="290" cy="' + (F - 1) + '" rx="9" ry="1.8" fill="#1b1b1b"/>'
    + pampas
    + '<path d="M283 ' + (F - 49) + ' Q281 ' + (F - 60) + ' 285 ' + (F - 67) + ' H293 Q297 ' + (F - 60) + ' 295 ' + (F - 49) + ' Z" fill="#efe9df" stroke="#cfc5b6" stroke-width=".5"/>'
    // maatlijn
    + '<g font-family="Inter,system-ui,sans-serif" font-size="5" fill="#5b4a36"><path d="M60 ' + (F + 30) + ' h200 M60 ' + (F + 28) + ' v4 M260 ' + (F + 28) + ' v4" stroke="#5b4a36" stroke-width=".5" opacity=".8"/><text x="' + CX + '" y="' + (F + 26.5) + '" text-anchor="middle" opacity=".85">Sofa 200 cm</text></g>';

  var overlay, svg, posterG, titleEl, sizeRow, finishRow, prevBody = '', view = null, anim = 0;

  // Vaste camera net ruim genoeg voor de hele bank, zodat de poster groter in beeld komt.
  // Voor elk formaat dezelfde camera, zodat het verschil tussen A4 en A1 klopt.
  var ZOOM = { A4: 246, A3: 246, A2: 246, A1: 246 };
  function targetView(size) {
    var vw = ZOOM[size] || W, vh = vw * H / W;
    var vx = Math.max(0, Math.min(W - vw, CX - vw / 2));
    var vy = Math.max(0, Math.min(H - vh, (FLOOR + 6) - vh));
    return [vx, vy, vw, vh];
  }
  function setView(size, animate) {
    var to = targetView(size);
    cancelAnimationFrame(anim);
    if (!animate || !view) { view = to; svg.setAttribute('viewBox', to.join(' ')); return; }
    var from = view.slice(), t0 = 0;
    function step(t) {
      if (!t0) t0 = t;
      var k = Math.min(1, (t - t0) / 450), e = 1 - Math.pow(1 - k, 3);
      view = from.map(function (v, i) { return v + (to[i] - v) * e; });
      svg.setAttribute('viewBox', view.join(' '));
      if (k < 1) anim = requestAnimationFrame(step);
    }
    anim = requestAnimationFrame(step);
  }
  var state = { size: current(opts.size, 'A3'), finish: current(opts.finish, 'poster') };

  function el(name, attrs) {
    var n = document.createElementNS(NS, name);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    return n;
  }

  function drawPoster() {
    while (posterG.firstChild) posterG.removeChild(posterG.firstChild);
    var d = SIZES[state.size], w = d[0], h = d[1];
    var x = CX - w / 2, y = CENTER_Y - h / 2;
    if (state.finish === 'framed') {
      var b = 1.8;
      posterG.appendChild(el('rect', { x: x - b, y: y - b, width: w + 2 * b, height: h + 2 * b, fill: '#141414', filter: 'url(#kfwShadow)' }));
      posterG.appendChild(el('image', { href: src, x: x, y: y, width: w, height: h, preserveAspectRatio: 'xMidYMid slice' }));
      posterG.appendChild(el('rect', { x: x, y: y, width: w, height: h * 0.45, fill: '#fff', opacity: '.07' }));
    } else if (state.finish === 'hanger') {
      var rod = 1.1, over = 1.2;
      posterG.appendChild(el('path', { d: 'M' + (x + 3) + ' ' + (y - rod) + ' L' + CX + ' ' + (y - 12) + ' L' + (x + w - 3) + ' ' + (y - rod), stroke: '#2a2a2a', 'stroke-width': '.35', fill: 'none' }));
      posterG.appendChild(el('circle', { cx: CX, cy: y - 12, r: '.8', fill: '#444' }));
      posterG.appendChild(el('image', { href: src, x: x, y: y, width: w, height: h, preserveAspectRatio: 'xMidYMid slice', filter: 'url(#kfwShadow)' }));
      posterG.appendChild(el('rect', { x: x - over, y: y - rod, width: w + 2 * over, height: rod * 2, rx: '.4', fill: '#1b1b1b' }));
      posterG.appendChild(el('rect', { x: x - over, y: y + h - rod, width: w + 2 * over, height: rod * 2, rx: '.4', fill: '#1b1b1b' }));
    } else {
      posterG.appendChild(el('image', { href: src, x: x, y: y, width: w, height: h, preserveAspectRatio: 'xMidYMid slice', filter: 'url(#kfwShadow)' }));
    }
    setView(state.size, true);
    var names = { framed: 'in a black wooden frame', hanger: 'with a black wooden hanger', poster: 'unframed' };
    titleEl.innerHTML = state.size + ' · ' + w + ' × ' + h + ' cm <small>' + names[state.finish] + ' · shown at real size above a 200 cm sofa</small>';
    sizeRow.querySelectorAll('.kfw-chip').forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-v') === state.size ? 'true' : 'false'); });
    finishRow.querySelectorAll('.kfw-chip').forEach(function (c) { c.setAttribute('aria-pressed', c.getAttribute('data-v') === state.finish ? 'true' : 'false'); });
  }

  // keuze ook in het productformulier zetten, zodat de juiste variant in de winkelwagen komt
  function pick(list, key) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].key === key && !list[i].el.checked) {
        list[i].el.checked = true;
        list[i].el.dispatchEvent(new Event('change', { bubbles: true }));
        break;
      }
    }
  }

  function chip(row, value, label, onClick) {
    var c = document.createElement('button');
    c.type = 'button'; c.className = 'kfw-chip'; c.textContent = label; c.setAttribute('data-v', value);
    c.addEventListener('click', function () { onClick(value); });
    row.appendChild(c);
  }

  function noScroll(e) { e.preventDefault(); }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'kfw';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Poster on a wall, at real size');
    var scene = document.createElement('div');
    scene.className = 'kfw-scene';
    svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, role: 'img', 'aria-label': 'Poster on a living room wall' });
    svg.innerHTML = room;
    posterG = el('g', { class: 'kfw-poster' });
    svg.appendChild(posterG);
    scene.appendChild(svg);
    titleEl = document.createElement('p'); titleEl.className = 'kfw-title';
    sizeRow = document.createElement('div'); sizeRow.className = 'kfw-row';
    finishRow = document.createElement('div'); finishRow.className = 'kfw-row';
    opts.size.forEach(function (s) { chip(sizeRow, s.key, s.key, function (v) { state.size = v; pick(opts.size, v); drawPoster(); }); });
    var seen = {};
    var labels = { poster: 'Unframed', framed: 'Framed', hanger: 'With hanger' };
    opts.finish.forEach(function (o) {
      if (seen[o.key]) return; seen[o.key] = 1;
      chip(finishRow, o.key, labels[o.key], function (v) { state.finish = v; pick(opts.finish, v); drawPoster(); });
    });
    var close = document.createElement('button');
    close.type = 'button'; close.className = 'kfw-close'; close.setAttribute('aria-label', 'Close'); close.innerHTML = '&times;';
    close.addEventListener('click', hide);
    overlay.appendChild(close);
    overlay.appendChild(scene);
    overlay.appendChild(titleEl);
    var controls = document.createElement('div'); controls.className = 'kfw-controls';
    controls.appendChild(sizeRow);
    if (opts.finish.length) controls.appendChild(finishRow);
    overlay.appendChild(controls);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) hide(); });
    overlay.addEventListener('wheel', noScroll, { passive: false });
    overlay.addEventListener('touchmove', noScroll, { passive: false });
  }

  function onKey(e) { if (e.key === 'Escape') hide(); }

  function show() {
    if (!overlay) build();
    state.size = current(opts.size, state.size);
    state.finish = current(opts.finish, state.finish);
    view = null;
    drawPoster();
    setView(state.size, false);
    document.body.appendChild(overlay);
    prevBody = document.body.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { overlay.classList.add('is-open'); });
    document.addEventListener('keydown', onKey);
    overlay.querySelector('.kfw-close').focus({ preventScroll: true });
  }

  function hide() {
    overlay.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = prevBody;
    document.removeEventListener('keydown', onKey);
    setTimeout(function () { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 250);
    btn.focus({ preventScroll: true });
  }

  btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(); });
})();
